import { useState, useEffect } from 'react';
import './Navbar.css';
import { smoothScrollTo } from '../utils/smoothScroll';

const NAV_LINKS = [
  { label: 'Anasayfa', id: 'anasayfa' },
  { label: 'Hizmetler', id: 'hizmetler' },
  { label: 'Hakkımızda', id: 'hakkimizda' },
  { label: 'İletişim', id: 'iletisim' },
  { label: 'Galeri', id: 'galeri' },
];

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    smoothScrollTo(id);
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__logo" onClick={() => scrollTo('anasayfa')}>
        <div className="navbar__logo-icon">💧</div>
        <span className={`navbar__logo-text ${scrolled ? 'navbar__logo-text--dark' : ''}`}>
          Akış Tesisat
        </span>
      </div>

      <div className="navbar__links">
        {NAV_LINKS.map((link) => (
          <button
            key={link.id}
            className={`navbar__link ${scrolled ? 'navbar__link--dark' : ''}`}
            onClick={() => scrollTo(link.id)}
          >
            {link.label}
          </button>
        ))}
      </div>

      <a href="tel:+905469314601" className="navbar__cta">
        📞 Hemen Ara
      </a>

      <button className={`navbar__hamburger ${scrolled ? 'navbar__hamburger--dark' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
        ☰
      </button>

      {menuOpen && (
        <div className="navbar__mobile-menu">
          {NAV_LINKS.map((link) => (
            <button key={link.id} className="navbar__mobile-link" onClick={() => scrollTo(link.id)}>
              {link.label}
            </button>
          ))}
          <a href="tel:+905001234567" className="navbar__mobile-cta">📞 Hemen Ara</a>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
